/**
 * Routes for the System Config domain
 */
export const routes = {
  systemConfig: {
    root: '/system-config',
    communityManagement: '/system-config/community-management',
    labelManagement: '/system-config/label-management',
    policyManagement: '/system-config/policy-management',
  },
};
